var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'hover:tw-no-underline',
    _vm.isSelected ? 'tw-text-[#1F2229]' : 'tw-text-white hover:tw-text-current'
  ],on:{"click":function($event){return _vm.setActiveArea(_vm.page)}}},[_c('li',{class:[
      'tw-flex tw-justify-between tw-items-center',
      'tw-py-2 tw-px-4 tw-rounded-lg',
      'tw-font-poppins tw-text-sm tw-font-medium tw-whitespace-nowrap',
      'tw-cursor-pointer',
      _vm.isSelected ? 'tw-bg-white' : 'hover:tw-bg-black hover:tw-bg-opacity-20',
    ]},[_vm._t("default",function(){return [_vm._v("\n      "+_vm._s(_vm.display || _vm.autoDisplayName)+"\n    ")]}),_vm._v(" "),(_vm.isSelected)?_c('i',{staticClass:"fa fa-arrow-right tw-text-[#F1583D]"}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }